<template>
  <div class="serve-scale-wrapper">
    <div class="serve">
      <!-- 定义 SVG 渐变，用于 el-progress -->
      <svg width="0" height="0" style="position: absolute">
        <defs>
          <linearGradient
            id="progress-gradient"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stop-color="rgba(72, 79, 241, 1)" />
            <stop offset="100%" stop-color="rgba(97, 36, 172, 1)" />
          </linearGradient>
        </defs>
      </svg>
      <div class="filter-wrapper">
        <CommonFilterBar
          :initialValues="initialValues"
          :fields="filterFields"
          :loading="loading"
          @search="onSearch"
          @export="onExport"
        />
      </div>
      <div class="card-wrapper" v-loading="cardLoading">
        <DataCard
          class="target-card"
          :list="salesTargetData"
          :name="`较上${dateType[initialValues.timeUnit]}`"
        >
          <div class="progress-box">
            <div class="progress-body">
              <div class="cake-box">
                <div class="cake">
                  <div class="value">
                    {{ completionRate }}
                    <span>%</span>
                  </div>
                  <div class="text">完成率</div>
                </div>
                <el-progress
                  class="progress"
                  type="circle"
                  :stroke-width="4"
                  :percentage="completionRatePercent"
                  :width="110"
                ></el-progress>
              </div>
            </div>
            <div class="divider"></div>
          </div>
        </DataCard>
        <DataCard
          class="single-card"
          :list="orderSum"
          :name="`较上${dateType[initialValues.timeUnit]}`"
        />
        <DataCard
          class="multi-card"
          :list="cardData"
          :name="`较上${dateType[initialValues.timeUnit]}`"
        />
        <DataCard
          class="single-card"
          :list="perCustomerTransactionData"
          :name="`较上${dateType[initialValues.timeUnit]}`"
        />
        <DataCard
          class="single-card"
          :list="numberOrdersData"
          :name="`较上${dateType[initialValues.timeUnit]}`"
        />
      </div>
      <div class="table-wrapper">
        <div class="performance-comparison" v-loading="tableLoading">
          <div class="title">{{ initialValues.showDate }}门店业绩对比表</div>
          <DataTable
            :key="tableData.length"
            :tableData="tableData"
            :column="column"
            :summary-method="shopSummaryMethod"
          >
          </DataTable>
        </div>
        <div class="saleroom-pie" v-loading="pieLoading">
          <div class="title">各门店销售金额情况</div>
          <PieChart :data="pieData" style="height: calc(100% - 40px)" />
        </div>
      </div>
      <div class="channel-wrapper">
        <div class="channel-bar" v-loading="channelLoading">
          <div class="title">渠道销售情况</div>
          <BarChart
            :data="barData"
            :displayCount="5"
            :xAxisLabelMaxLength="5"
            style="height: calc(100% - 53px)"
          />
        </div>
        <div class="channel-table" v-loading="channelTableLoading">
          <div class="title">渠道业绩对比表</div>
          <DataTable
            :key="channelTableData.length"
            :tableData="channelTableData"
            :column="channelColumn"
            :summary-method="channelSummaryMethod"
          ></DataTable>
        </div>
      </div>
      <div class="salesman-wrapper">
        <div class="salesman-wrapper-left">
          <div class="salesperson-performance" v-loading="managerBarLoading">
            <div class="title">管家销售情况</div>
            <BarChart
              :data="managerBarData"
              :displayCount="10"
              style="height: calc(100% - 80px)"
            />
          </div>
          <div
            class="salesperson-performance-comparison"
            v-loading="managerTableLoading"
          >
            <div class="title">{{ initialValues.showDate }}管家业绩对比表</div>
            <DataTable
              :key="salesmanTableData.length"
              :tableData="salesmanTableData"
              :column="salesmanColumn"
              :summary-method="salesmanSummaryMethod"
            ></DataTable>
          </div>
        </div>
        <div class="salesman-wrapper-right" v-loading="rankingLoading">
          <div class="title-box">
            <div class="title">{{ initialValues.showDate }}客单价排名</div>
            <img class="ranking-icon" src="@/assets/ranking-icon.png" alt="" />
          </div>
          <div class="ranking-wrapper">
            <div class="ranking-box">
              <div
                class="ranking-item"
                :class="index == 0 ? 'ranking-item-one' : ''"
                v-for="(item, index) in rankingData"
              >
                <div class="ranking-left">
                  <div class="index-one" v-if="index == 0">
                    <img
                      class="index-icon"
                      src="@/assets/no1-icon.png"
                      alt=""
                    />
                  </div>
                  <div class="index-two" v-if="index < 3 && index > 0">
                    {{ index + 1 }}
                  </div>
                  <div class="index" v-if="index >= 3">{{ index + 1 }}</div>
                  <div
                    class="ranking-name"
                    :class="index == 0 ? 'index-one-name' : ''"
                  >
                    <span v-if="index == 0">NO.1</span>
                    {{ item.name }}
                  </div>
                </div>
                <div
                  class="ranking-value"
                  :class="index == 0 ? 'index-one-value' : ''"
                >
                  {{ item.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contrastive-analysis">
        <div class="contrastive-analysis-left" v-loading="trendLoading">
          <div class="title">业绩对比情况</div>
          <ComboChart
            class="combo-chart-panel"
            :data="performanceData"
            :displayCount="12"
          />
        </div>
        <div
          class="contrastive-analysis-right"
          v-loading="monthAnalysisLoading"
        >
          <div class="title">各月环比分析</div>
          <ComboChart
            class="combo-chart-panel"
            :data="monthAnalysisData"
            :displayCount="12"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFilterBar from "../components/common-filter-bar.vue";
import DataCard from "../components/data-card.vue";
import DataTable from "../components/data-table.vue";
import PieChart from "../components/pie-chart.vue";
import BarChart from "../components/bar-chart.vue";
import ComboChart from "../components/combo-chart.vue";
import {
  BiShopList,
  BiServiceUserList,
  BiSourecList,
  serviceOrderCount,
  exportMultiSimple,
} from "@/common/api";

export default {
  name: "serve",
  components: {
    CommonFilterBar,
    DataCard,
    DataTable,
    PieChart,
    BarChart,
    ComboChart,
  },
  data() {
    return {
      loading: false,
      cardLoading: false,
      tableLoading: false,
      pieLoading: false,
      channelLoading: false,
      channelTableLoading: false,
      managerBarLoading: false,
      managerTableLoading: false,
      rankingLoading: false,
      trendLoading: false,
      monthAnalysisLoading: false,
      completionRate: 0,
      completionRatePercent: 0,
      dateType: {
        day: "日",
        week: "周",
        month: "月",
        year: "年",
        diy: "段",
      },
      filterFields: [
        { label: "门店：", prop: "store", type: "select", options: [] },
        { label: "客户归属：", prop: "owner", type: "select", options: [] },
        { label: "销售渠道：", prop: "channel", type: "select", options: [] },
      ],
      initialValues: {
        timeUnit: "month", // 时间类型
        store: "", //门店
        owner: "", //管家
        channel: "", //渠道
        date: new Date(), // 初始时间
        startTime: "", //开始时间
        endTime: "", //结束时间
        showDate: "", //显示的时间
      },
      salesTargetData: [
        {
          title: "销售目标",
          value: "5500000000",
          unit: ".00",
          subTitle: "",
          compareLabel: "较上月",
          compareValue: "+2.01%",
          isUp: false,
          tagColor: "#09C3EC",
          gradient: "linear-gradient( 180deg, #D0F7FF 0%, #FFFFFF 63%)",
        },
      ],
      orderSum: [
        {
          title: "销售金额",
          value: "5500000000",
          unit: ".00",
          subTitle: "（含医美 整形 牙科）",
          compareLabel: "较上月",
          compareValue: "+2.01%",
          isUp: true,
          tagColor: "#8E82F2",
          gradient: "linear-gradient( 180deg, #DCE0FF 0%, #FFFFFF 63%)",
        },
      ],
      cardData: [
        {
          title: "医美销售金额",
          subTitle: "（不含税）",
          value: "5500000000",
          unit: ".00",
          compareLabel: "较上月",
          compareValue: "+2.01%",
          isUp: true,
          tagColor: "#8E82F2",
          gradient: "linear-gradient( 180deg, #DCE0FF 0%, #FFFFFF 63%)",
        },
        {
          title: "整形销售金额",
          subTitle: "（不含税）",
          value: "5500000000",
          unit: ".00",
          compareLabel: "较上月",
          compareValue: "+2.01%",
          isUp: true,
          tagColor: "#4F6BFF",
          gradient: "linear-gradient(180deg, #F2F3FF 0%, #FFFFFF 63%)",
        },
        {
          title: "牙科销售金额",
          subTitle: "（不含税）",
          value: "5500000000",
          unit: ".00",
          compareLabel: "较上月",
          compareValue: "+2.01%",
          isUp: true,
          tagColor: "#00CCF5",
          gradient: "linear-gradient(180deg, #F2F3FF 0%, #FFFFFF 63%)",
        },
      ],
      numberOrdersData: [
        {
          title: "客单数 ",
          value: "2690",
          unit: "",
          subTitle: "",
          compareLabel: "较上月",
          compareValue: "+2.01%",
          isUp: true,
          tagColor: "#FF6C3C",
          gradient: "linear-gradient( 180deg, #FFE2D9 0%, #FFFFFF 63%)",
        },
      ],
      perCustomerTransactionData: [
        {
          title: "客单价",
          value: "120690",
          unit: ".00",
          subTitle: "（不含税）",
          compareLabel: "较上月",
          compareValue: "+2.01%",
          isUp: true,
          tagColor: "#00C4A3",
          gradient: "linear-gradient( 180deg, #D0F6F1 0%, #FFFFFF 63%)",
        },
      ],
      tableData: [
        {
          customerBelonging: "江南店",
          orderNum: 123456789,
          salesRevenueExcludingTax: 123456789,
          salesRevenueIncludingTax: 123456789,
          salesRevenueRate: "50 %",
          customerUnitPriceExcludingTax: 123456789,
          customerUnitPriceIncludingTax: "123456789",
          monthOverMonthGrowthRate: "25",
        },
      ],
      shopSummaryRow: null,
      column: [
        {
          prop: "shopName",
          label: "门店",
        },
        {
          prop: "orderSize",
          label: "客单数",
        },
        {
          prop: "salesAmountExTax",
          label: "销售额（不含税）",
          width: "170",
        },
        {
          prop: "salesAmount",
          label: "销售额（含税）",
          width: "150",
        },
        {
          prop: "amountRatio",
          label: "金额占比",
          width: "100",
          formatter: (value) => this.formatRatio(value),
        },
        {
          prop: "unitPriceExTax",
          label: "客单价（不含税）",
          width: "170",
        },
        {
          prop: "unitPrice",
          label: "客单价（含税）",
          width: "150",
        },
        {
          prop: "growthRate",
          label: "环比增长率",
          arrows: true,
          width: "120",
          formatter: (value) => this.formatRatio(value),
          slotName: "monthOverMonthGrowthRateSlot",
        },
      ],
      pieData: [{ value: 5013, name: "江南店" }],
      barData: [{ name: "小程序", value: 1064859671 }],
      managerBarData: [],
      channelTableData: [
        {
          customerBelonging: "江南店",
          orderNum: 123456789,
          salesRevenueExcludingTax: 123456789,
          salesRevenueIncludingTax: 123456789,
          salesRevenueRate: "50 %",
          customerUnitPriceExcludingTax: 123456789,
          customerUnitPriceIncludingTax: "123456789",
          monthOverMonthGrowthRate: "25",
        },
      ],
      channelSummaryRow: null,
      salesmanSummaryRow: null,
      salesmanTableData: [],
      channelColumn: [
        {
          prop: "sourceName",
          label: "销售渠道",
        },
        {
          prop: "orderSize",
          label: "客单数",
        },
        {
          prop: "salesAmountExTax",
          label: "销售额（不含税）",
        },
        {
          prop: "salesAmount",
          label: "销售额（含税）",
        },
        {
          prop: "amountRatio",
          label: "金额占比",
          formatter: (value) => `${Number(value || 0).toFixed(2)}%`,
        },
        {
          prop: "unitPriceExTax",
          label: "客单价（不含税）",
        },
        {
          prop: "unitPrice",
          label: "客单价（含税）",
        },
      ],
      salesmanColumn: [
        {
          prop: "serviceUserName",
          label: "名称",
        },
        {
          prop: "orderSize",
          label: "客单数",
        },
        {
          prop: "salesAmountExTax",
          label: "销售额（不含税）",
          width: "150px",
        },
        {
          prop: "salesAmount",
          label: "销售额（含税）",
        },
        {
          prop: "amountRatio",
          label: "金额占比",
          formatter: (value) => `${Number(value || 0).toFixed(2)}%`,
        },
        {
          prop: "unitPriceExTax",
          label: "客单价（不含税）",
          width: "150px",
        },
        {
          prop: "unitPrice",
          label: "客单价（含税）",
          // slotName: 'unitPriceSlot'
        },
        {
          prop: "growthRate",
          label: "环比增长率",
          width: "180",
          arrows: true,
          slotName: "growthRateSlot",
        },
      ],
      rankingData: [{ name: "王婷", value: "1064859671" }],
      performanceData: [{ name: "1", barValue: 8800000, lineValue: 1.5 }],
      monthAnalysisData: [{ name: "1", barValue: 8800000, lineValue: 1.5 }],
    };
  },
  mounted() {
    this.getFilterItem();
  },
  methods: {
    // 筛选
    onSearch(e) {
      this.initialValues = e;
      this.serviceOrderCount();
    },
    // 导出
    async onExport(e) {
      console.log(e);
      let {
        startTime,
        endTime,
        timeUnit: typeEnum,
        store: shopId,
        owner: serviceUserId,
        channel: sourceCode,
      } = this.initialValues;
      this.loading = true;
      try {
        const params = {
          startTime, // 开始时间
          endTime, // 结束时间
          typeEnum: typeEnum.toUpperCase(), // 时间类型
          ...(shopId !== "" && { shopId }),
          ...(serviceUserId !== "" && { serviceUserId }),
          ...(sourceCode !== "" && { sourceCode }),
        };
        const res = await exportMultiSimple(params);

        // 从 headers 中提取文件名，如果获取不到则使用默认的文件名
        // const disposition = res.headers && res.headers['content-disposition']
        // let fileName = '服务看板导出数据.xlsx'
        // if (disposition) {
        //   const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        //   const matches = filenameRegex.exec(disposition)
        //   if (matches && matches[1]) {
        //     fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''))
        //   }
        // }

        // 创建 Blob 并下载
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "服务看板导出数据.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error(error);
        this.$message.error("导出失败");
      } finally {
        this.loading = false;
      }
    },
    // 将接口可能返回的字符串、null 等统一转成数字，避免图表或计算出现 NaN。
    toNumber(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    },
    // DataCard 的金额由整数部分和小数 unit 分开显示，这里统一拆分。
    formatAmountParts(value) {
      const [valueText, decimalText = "00"] = this.toNumber(value)
        .toFixed(2)
        .split(".");
      return {
        value: valueText,
        unit: `.${decimalText}`,
      };
    },
    // 卡片底部环比文案，正数补 +，并统一保留两位小数。
    formatCompare(value) {
      const num = this.toNumber(value);
      return `${num > 0 ? "+" : ""}${num.toFixed(2)}%`;
    },
    // 趋势字段用于控制 DataCard 的上升/下降样式。
    isUpTrend(value) {
      return this.toNumber(value) >= 0;
    },
    // 表格金额占比统一带百分号。
    formatRatio(value) {
      return `${this.toNumber(value).toFixed(2)}%`;
    },
    // 排名等纯文本位置需要直接展示千分位格式。
    formatTableNumber(value) {
      return this.toNumber(value).toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    // 保留原卡片的标题、颜色和渐变，只替换接口返回的数值与趋势。
    formatCard(item, value, compare) {
      const amount = this.formatAmountParts(value);
      return {
        ...item,
        value: amount.value,
        unit: amount.unit,
        compareValue: this.formatCompare(compare),
        isUp: this.isUpTrend(compare),
      };
    },
    // 将 serviceOrderCount 的接口结果映射到页面所有卡片、表格和图表。
    updateServiceOrderView(data = {}) {
      const shopList = data.groupByShopList || [];
      const sourceList = data.groupBySourceCodeList || [];
      const serviceUserList = data.groupByServiceUserList || [];
      const monthList =
        data.koreaPriceSumGroupByMonthList ||
        data.koreaPriceSumGroupBYMonthList ||
        [];
      // 图表和排名不展示“总计”行，门店表把最后一项单独交给 summary-method。
      const shopTotal = shopList.length ? shopList[shopList.length - 1] : null;
      const shopDetailList = shopList.length ? shopList.slice(0, -1) : [];
      const sourceTotal = sourceList.length
        ? sourceList[sourceList.length - 1]
        : null;
      const sourceDetailList = sourceList.length ? sourceList.slice(0, -1) : [];
      const serviceUserTotal = serviceUserList.length
        ? serviceUserList[serviceUserList.length - 1]
        : null;
      const serviceUserDetailList = serviceUserList.length
        ? serviceUserList.slice(0, -1)
        : [];
      const shopRows = shopList.filter((item) => item.shopId !== null);
      const sourceRows = sourceList.filter((item) => item.sourceCode !== null);
      const serviceUserRows = serviceUserDetailList;
      const serviceUserSalesRows = [...serviceUserDetailList].sort(
        (a, b) =>
          this.toNumber(b.salesAmountExTax) - this.toNumber(a.salesAmountExTax),
      );

      // 顶部销售目标、销售金额、客单数、客单价等卡片。
      const completionRate = this.toNumber(data.completionRate);
      this.completionRate = completionRate.toFixed(2);
      // el-progress 只接受 0-100，文字仍保留接口原始完成率。
      this.completionRatePercent = Math.min(Math.max(completionRate, 0), 100);
      this.salesTargetData = [
        this.formatCard(
          this.salesTargetData[0],
          data.monthlySalesTarget,
          data.completionRateCompare,
        ),
      ];
      this.orderSum = [
        this.formatCard(
          this.orderSum[0],
          data.koreaPriceSum,
          data.koreaPriceSumCompare,
        ),
      ];
      this.cardData = [
        this.formatCard(
          this.cardData[0],
          data.medicalSalesAmountExTax,
          data.medicalSalesAmountExTaxCompare,
        ),
        this.formatCard(
          this.cardData[1],
          data.plasticSalesAmountExTax,
          data.plasticSalesAmountExTaxCompare,
        ),
        this.formatCard(
          this.cardData[2],
          data.dentalSalesAmountExTax,
          data.dentalSalesAmountExTaxCompare,
        ),
      ];
      this.numberOrdersData = [
        {
          ...this.numberOrdersData[0],
          value: this.formatTableNumber(data.orderSize),
          unit: "",
          compareValue: this.formatCompare(data.orderSizeCompare),
          isUp: this.isUpTrend(data.orderSizeCompare),
        },
      ];
      this.perCustomerTransactionData = [
        this.formatCard(
          this.perCustomerTransactionData[0],
          data.koreaPriceOne,
          data.koreaPriceOneCompare,
        ),
      ];

      // 门店业绩表和门店销售金额饼图。
      this.tableData = shopDetailList;
      this.shopSummaryRow = shopTotal || null;
      this.pieData = shopRows.map((item) => ({
        name: item.shopName || "-",
        value: this.toNumber(item.salesAmountExTax),
      }));
      // 渠道销售柱状图和渠道业绩表。
      this.barData = sourceRows.map((item) => ({
        name: item.sourceName || "-",
        value: this.toNumber(item.salesAmountExTax),
      }));
      this.channelTableData = sourceDetailList;
      this.channelSummaryRow = sourceTotal;
      // 管家销售柱状图、管家业绩表和右侧客单价排名。
      this.managerBarData = serviceUserSalesRows.map((item) => ({
        name: item.serviceUserName || "-",
        value: this.toNumber(item.salesAmountExTax),
      }));
      this.salesmanTableData = serviceUserSalesRows;
      this.salesmanSummaryRow = serviceUserTotal;
      this.rankingData = serviceUserRows.map((item) => ({
        name: item.serviceUserName || "-",
        value: this.formatTableNumber(item.unitPriceExTax),
      }));
      // 月度业绩对比：柱状图显示销售额，折线显示销售额环比。
      this.performanceData = monthList.map((item) => ({
        name: item.month,
        barValue: this.toNumber(item.salesAmountExTax),
        lineValue: this.toNumber(item.salesAmountExTaxGrowthRate) / 100,
      }));
      // 月度环比分析：柱状图显示客单价，折线显示客单价环比。
      this.monthAnalysisData = monthList.map((item) => ({
        name: item.month,
        barValue: this.toNumber(item.unitPriceExTax),
        lineValue: this.toNumber(item.unitPriceExTaxGrowthRate) / 100,
      }));
    },
    async getFilterItem() {
      const res1 = await BiShopList({
        status: 0,
        pageNo: 1,
        pageSize: 9999,
      });
      const res2 = await BiServiceUserList();
      const res3 = await BiSourecList({
        pageNo: 1,
        pageSize: 99999,
      });
      this.filterFields[0].options = res1.data.records.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      this.filterFields[1].options = res2.data.map((item) => ({
        value: item.serviceUserId,
        label: item.serviceUserName,
      }));
      this.filterFields[2].options = res3.data.records.map((item) => ({
        value: item.sourceCode,
        label: item.sourceName,
      }));
    },
    async serviceOrderCount() {
      let {
        startTime,
        endTime,
        timeUnit: typeEnum,
        store: shopId,
        owner: serviceUserId,
        channel: sourceCode,
      } = this.initialValues;
      this.loading = true;
      this.cardLoading = true;
      this.tableLoading = true;
      this.pieLoading = true;
      this.channelLoading = true;
      this.channelTableLoading = true;
      this.managerBarLoading = true;
      this.managerTableLoading = true;
      this.rankingLoading = true;
      this.trendLoading = true;
      this.monthAnalysisLoading = true;
      try {
        const params = {
          startTime, // 开始时间
          endTime, // 结束时间
          typeEnum: typeEnum.toUpperCase(), // 时间类型
          ...(shopId !== "" && { shopId }),
          ...(serviceUserId !== "" && { serviceUserId }),
          ...(sourceCode !== "" && { sourceCode }),
        };
        let res = await serviceOrderCount(params);
        if (res && res.code === 0) {
          this.updateServiceOrderView(res.data);
        }
      } finally {
        this.loading = false;
        this.cardLoading = false;
        this.tableLoading = false;
        this.pieLoading = false;
        this.channelLoading = false;
        this.channelTableLoading = false;
        this.managerBarLoading = false;
        this.managerTableLoading = false;
        this.rankingLoading = false;
        this.trendLoading = false;
        this.monthAnalysisLoading = false;
      }
    },
    // 门店业绩最后一行
    performanceComparisonSum(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        sums[index] = index;
        // if (index === 0) {
        //   sums[index] = '';
        //   return;
        // }
        // const values = data.map(item => Number(item[column.property]));
        // if (!values.every(value => isNaN(value))) {
        //   sums[index] = values.reduce((prev, curr) => {
        //     const value = Number(curr);
        //     if (!isNaN(value)) {
        //       return prev + curr;
        //     } else {
        //       return prev;
        //     }
        //   }, 0);
        //   sums[index] += ' 元';
        // } else {
        //   sums[index] = 'N/A';
        // }
      });

      return sums;
    },
    // 门店业绩合计行：直接使用 groupByShopList 接口返回的最后一项。
    shopSummaryMethod({ columns }) {
      if (!this.shopSummaryRow) return columns.map(() => "");
      return columns.map((column, index) => {
        if (index === 0) return this.shopSummaryRow.shopName || "总计";
        if (
          column.property === "amountRatio" ||
          column.property === "growthRate"
        ) {
          return this.formatRatio(this.shopSummaryRow[column.property]);
        }
        return this.shopSummaryRow[column.property] !== undefined
          ? this.shopSummaryRow[column.property]
          : "";
      });
    },
    // 渠道业绩合计行：直接使用 groupBySourceCodeList 接口返回的最后一项。
    channelSummaryMethod({ columns }) {
      if (!this.channelSummaryRow) return columns.map(() => "");
      return columns.map((column, index) => {
        if (index === 0) return this.channelSummaryRow.sourceName || "总计";
        if (column.property === "amountRatio")
          return this.formatRatio(this.channelSummaryRow[column.property]);
        return this.channelSummaryRow[column.property] !== undefined
          ? this.channelSummaryRow[column.property]
          : "";
      });
    },
    // 管家业绩合计行：直接使用 groupByServiceUserList 接口返回的最后一项。
    salesmanSummaryMethod({ columns }) {
      if (!this.salesmanSummaryRow) return columns.map(() => "");
      return columns.map((column, index) => {
        if (index === 0)
          return this.salesmanSummaryRow.serviceUserName || "总计";
        if (
          column.property === "amountRatio" ||
          column.property === "growthRate"
        ) {
          return this.formatRatio(this.salesmanSummaryRow[column.property]);
        }
        return this.salesmanSummaryRow[column.property] !== undefined
          ? this.salesmanSummaryRow[column.property]
          : "";
      });
    },
  },
};
</script>

<style scoped lang="scss">
.serve-scale-wrapper {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: #f5f7fa;
}

.serve {
  // padding: 20px;
  width: 100%;
  box-sizing: border-box;
  background-color: #f5f7fa;
  min-height: 100vh;

  .title {
    font-weight: 500;
    font-size: 20px;
    color: #000000;
    line-height: 33px;
    margin-bottom: 20px;
  }

  .filter-wrapper {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .card-wrapper {
    display: grid;
    grid-template-columns:
      minmax(350px, 1.4fr) minmax(215px, 1fr) minmax(645px, 2.6fr)
      minmax(215px, 1fr) minmax(215px, 1fr);
    gap: 16px;
    align-items: stretch;

    ::v-deep .data-card-panel {
      min-width: 0;
      width: 100%;
      overflow: hidden;
    }

    ::v-deep .data-card-panel .data-item {
      flex: 1 0 215px;
    }

    .target-card {
      min-width: 350px;
    }

    .single-card {
      min-width: 215px;
    }

    .multi-card {
      min-width: 645px;
    }

    .progress-box {
      width: 135px;
      flex: 0 0 135px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .progress-body {
        width: 110px;
        height: 110px;

        .cake-box {
          position: relative;

          ::v-deep .el-progress {
            display: block;

            .el-progress__text {
              display: none;
            }

            // 将进度条路径指向定义的 SVG 渐变
            .el-progress-circle__path {
              stroke: url(#progress-gradient);
            }
          }

          .cake {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 90px;
            height: 90px;
            border-radius: 50%;
            background: linear-gradient(138deg, #16a6fd 0%, #5219cf 100%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .value {
              font-weight: 900;
              color: #fff;
              font-size: 14px;

              span {
                font-size: 10px;
              }
            }

            .text {
              font-weight: 600;
              color: #fff;
              font-size: 8px;
              margin-top: 4px;
            }
          }
        }

        // border-radius: 50%;
        // background-color: #fff;
      }

      .divider {
        position: absolute;
        left: 0;
        top: 16%;
        width: 1px;
        height: 100px;
        background: linear-gradient(
          to bottom,
          transparent,
          #eeeeee,
          transparent
        );
      }
    }
  }

  .table-wrapper {
    margin-top: 24px;
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(300px, 1fr);
    gap: 24px;

    .performance-comparison {
      min-width: 0;
      height: 416px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 24px 38px 38px 38px;
      display: flex;
      flex-direction: column;

      .data-table {
        flex: 1;
        min-height: 0;
        height: auto !important;
        overflow: hidden;
        width: 100%;
      }
    }

    .saleroom-pie {
      min-width: 0;
      height: 416px;
      background: #ffffff;
      box-sizing: border-box;
      padding: 24px 38px 38px 38px;
    }
  }

  .channel-wrapper {
    width: 100%;
    height: 529px;
    background: #ffffff;
    box-sizing: border-box;
    padding: 24px 38px 38px 38px;
    display: grid;
    grid-template-columns: minmax(300px, 1fr) minmax(0, 2fr);
    align-items: stretch;
    gap: 24px;
    margin-top: 24px;
    overflow: hidden;

    .channel-bar {
      min-width: 0;
      min-height: 0;
      height: 100%;
    }

    .channel-table {
      min-width: 0;
      min-height: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      ::v-deep .data-table {
        flex: 1;
        min-height: 0;
        height: auto !important;
        overflow: hidden;
        width: 100%;
      }
    }
  }

  .salesman-wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(300px, 1fr);
    gap: 24px;
    margin-top: 24px;

    .salesman-wrapper-left {
      min-width: 0;
      height: 870px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      padding: 24px 38px 38px 38px;

      .salesperson-performance {
        flex: 1;
      }

      .salesperson-performance-comparison {
        height: 420px;
        display: flex;
        flex-direction: column;

        ::v-deep .data-table {
          flex: 1;
          min-height: 0;
          height: auto !important;
          overflow: hidden;
          width: 100%;
        }
      }
    }

    .salesman-wrapper-right {
      min-width: 0;
      height: 870px;
      background: #ffffff;
      display: flex;
      flex-direction: column;

      .title-box {
        width: 100%;
        height: 109px;
        padding: 17px 17px 8px 17px;
        background: linear-gradient(
          180deg,
          #ebf1fc 0%,
          rgba(235, 241, 252, 0) 100%
        );
        display: flex;
        justify-content: space-between;

        .title {
          font-weight: 500;
          font-size: 22px;
          color: #000000;
          line-height: 33px;
          margin-top: 21px;
        }

        .ranking-icon {
          width: 142px;
          height: 100px;
          margin: 0;
        }
      }

      .ranking-wrapper {
        flex: 1;
        padding: 27px 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        min-height: 0;
      }

      .ranking-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .ranking-item {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 32px;
          padding: 0 14px;

          &.ranking-item-one {
            background: linear-gradient(270deg, #fcfdff 0%, #fafcff 100%);
          }

          .ranking-left {
            display: flex;
            align-items: center;

            .index-one {
              flex-shrink: 0;
              .index-icon {
                width: 64px;
                height: 64px;
                flex-shrink: 0;
              }
            }

            .index-two {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background: #3c7ce0;
              font-weight: 900;
              font-size: 16px;
              color: #ffffff;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;
              line-height: 1;
              flex-shrink: 0;
            }

            .index {
              width: 30px;
              height: 30px;
              background: #ecedf0;
              font-weight: 900;
              font-size: 16px;
              color: #333333;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              line-height: 1;
              margin-left: 10px;
              flex-shrink: 0;
            }

            .ranking-name {
              margin-left: 28px;
              font-weight: 500;
              font-size: 16px;
              color: #333333;

              &.index-one-name {
                font-weight: 900;
                margin-left: 12px;
                font-size: 18px;
                color: #3c7ce0;
                line-height: 37px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                min-width: 0;
              }
            }
          }

          .ranking-value {
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            line-height: 30px;

            &.index-one-value {
              font-weight: 900;
              font-size: 18px;
              color: #3c7ce0;
              line-height: 37px;
            }
          }
        }
      }
    }
  }

  .contrastive-analysis {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
    margin-top: 24px;

    .contrastive-analysis-left {
      min-width: 0;
      height: 578px;
      background: #ffffff;
      padding: 24px 38px 38px 38px;
      display: flex;
      flex-direction: column;
    }

    .contrastive-analysis-right {
      min-width: 0;
      height: 578px;
      background: #ffffff;
      padding: 24px 38px 38px 38px;
      display: flex;
      flex-direction: column;
    }

    .combo-chart-panel {
      flex: 1;
      min-height: 0;
    }
  }
}

@media (max-width: 1439px) {
  .serve-scale-wrapper {
    overflow-x: hidden;
  }
}

@media (min-width: 1440px) and (max-width: 1700px) {
  .serve {
    .card-wrapper {
      grid-template-columns: minmax(350px, 1.4fr) minmax(215px, 1fr) minmax(
          645px,
          2.6fr
        );
    }
  }
}
</style>
